/* eslint-disable react/prop-types */
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from "chart.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

/**
 * Bar chart for the {day, date, count} rows returned by
 * /analytics/weekly-attendance. Used on the admin dashboard and the
 * attendance report page.
 */
export default function WeeklyAttendanceChart({ data }) {
  const theme = useTheme();

  if (!data || data.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No attendance recorded in the last 7 days.
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((d) => d.day),
    datasets: [
      {
        label: "Attendance",
        data: data.map((d) => d.count),
        backgroundColor: theme.palette.teal[400],
        hoverBackgroundColor: theme.palette.teal[600],
        borderRadius: 6,
        maxBarThickness: 36,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => data[items[0].dataIndex].date,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: true, ticks: { precision: 0 }, grid: { color: theme.palette.ink[100] } },
    },
  };

  return (
    <Box sx={{ height: 260 }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
}
